import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFlagTriangleRegularIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 32 32",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#a)",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M7 4q-.1-1.3-1.3-1.3a1.2 1.2 0 0 0-1.3 1.2v24.2q.1 1.1 1.3 1.2t1.2-1.2v-7.2l19.9-7.1a1.2 1.2 0 0 0 0-2.2L6.9 4.4zm0 3 15.5 5.7L7 18.3z"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "a",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M4.4 2.7h23.2v26.6H4.4z"
		})
	}) })]
});
export default SvgFlagTriangleRegularIcon;
